export function DefaultLoadingScreen() {
    return <div />;
}
export default DefaultLoadingScreen;
